<template>
    <div class="tools-bar">
        <button
            class="tools-bar__chip tools-bar__filters"
            :class="{ 'tools-bar__chip_on': isFiltersActive }"
            type="button"
            @click="$emit('toggleFilter')"
        >
            <TuneIcon class="tools-bar__chip-icon" :size="16"></TuneIcon>
            <span>Фильтры</span>
            <span class="tools-bar__badge" v-if="activeFiltersCount > 0">{{ activeFiltersCount }}</span>
        </button>

        <button
            v-if="showGlobalSearch"
            class="tools-bar__chip tools-bar__global-search"
            type="button"
            @click="openGlobalSearch"
        >
            <MagnifyIcon class="tools-bar__chip-icon" :size="16"></MagnifyIcon>
            <span>Поиск везде</span>
        </button>

        <button
            class="tools-bar__chip tools-bar__chip_quiet tools-bar__export"
            type="button"
            v-if="showExportButton"
            :disabled="isExporting"
            @click="$emit('export')"
        >
            <DownloadIcon class="tools-bar__chip-icon" :size="16"></DownloadIcon>
            <span class="tools-bar__chip-text">{{ isExporting ? 'Выгружаем...' : 'Выгрузить в Excel' }}</span>
        </button>

        <div class="tools-bar__sort" v-if="!hideSort">
            <span class="tools-bar__sort-label">СОРТИРОВКА</span>

            <VSelect
                class="tools-bar__sort-select"
                :options="targets"
                label="title"
                :reduce="(target) => target.type"
                :clearable="false"
                :searchable="false"
                v-model="selectedType"
            ></VSelect>

            <button
                class="tools-bar__sort-direction"
                type="button"
                :title="sort.reverse ? 'По убыванию' : 'По возрастанию'"
                @click="toggleDirection"
            >
                <SortAscending :size="16" v-if="sort.reverse"></SortAscending>
                <SortDescending :size="16" v-else></SortDescending>
            </button>
        </div>
    </div>
</template>
<script>
import titles from '@/js/enums/RequestSortTitle';

import VSelect from '@/views/components/VSelect/VSelect.vue';
import TuneIcon from 'vue-material-design-icons/Tune.vue';
import DownloadIcon from 'vue-material-design-icons/Download.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import ModalNames from '@/js/enums/ModalNames';
import SortAscending from 'vue-material-design-icons/SortAscending.vue';
import SortDescending from 'vue-material-design-icons/SortDescending.vue';

export default {
    components: {
        VSelect,
        TuneIcon,
        DownloadIcon,
        MagnifyIcon,
        SortAscending,
        SortDescending,
    },
    props: {
        sort: {
            type: Object,
            required: true,
        },
        isFiltersActive: Boolean,
        showExportButton: Boolean,
        isExporting: Boolean,
        hideSort: Boolean,
        activeFiltersCount: {
            type: Number,
            default: 0,
        },
        showGlobalSearch: Boolean,
    },
    data: () => ({
        targets: Object.keys(titles).map((key) => ({ type: Number(key), title: titles[key] })),
    }),
    computed: {
        selectedType: {
            get() {
                return this.sort.type;
            },
            set(type) {
                const reverse = this.sort.type === type ? this.sort.reverse : true;
                this.$emit('sort', { type, reverse });
            },
        },
    },
    methods: {
        openGlobalSearch() {
            this.$modal.show(ModalNames.GLOBAL_SEARCH);
        },
        toggleDirection() {
            this.$emit('sort', { type: this.sort.type, reverse: !this.sort.reverse });
        },
    },
};
</script>
<style lang="scss">
.tools-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    &__chip {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        height: 34px;
        padding: 0 14px;
        border-radius: 999px;
        border: 1px solid #e3e5e8;
        background: var(--color-white);
        color: #3c4043;
        font: 500 0.8125rem var(--font-family);
        cursor: pointer;
        white-space: nowrap;

        &:hover {
            background: #f6f7f8;
            border-color: #d4d7db;
        }

        &:disabled {
            opacity: 0.6;
            cursor: default;
        }
    }

    &__chip-icon {
        color: #5f6368;
    }

    &__chip_quiet {
        color: #5f6368;
    }

    &__chip_on {
        background: #e8f5e9;
        border-color: #a5d6a7;
        color: #2e7d32;
        font-weight: 600;

        &:hover {
            background: #e8f5e9;
        }

        .tools-bar__chip-icon {
            color: #2e7d32;
        }
    }

    &__badge {
        min-width: 18px;
        height: 18px;
        border-radius: 9px;
        background: $green;
        color: var(--text-white);
        font: 600 0.6875rem/18px var(--font-family);
        text-align: center;
        padding: 0 5px;
    }

    &__sort {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-left: auto;
    }

    &__sort-label {
        font: 600 0.6875rem var(--font-family);
        letter-spacing: 0.06em;
        color: #9aa0a6;
    }

    &__sort-select {
        width: 190px;

        &.custom-select.v-select .vs__dropdown-toggle {
            min-height: 34px;
            padding: 6px 10px;
        }
    }

    &__sort-direction {
        display: inline-flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        width: 34px;
        height: 34px;
        padding: 0;
        border: 1px solid #e3e5e8;
        border-radius: 8px;
        background: var(--color-white);
        color: #5f6368;
        cursor: pointer;

        &:hover {
            background: #f6f7f8;
            border-color: #d4d7db;
        }
    }
}

@media (max-width: $mobile-breakpoint) {
    .tools-bar__global-search {
        padding: 0 10px;
    }
    .tools-bar__sort {
        margin-left: 0;
        width: 100%;
        overflow-x: auto;
    }

    .tools-bar__chip-text {
        display: none;
    }
}
</style>
